import { render, staticRenderFns } from "./GenerateTab.vue?vue&type=template&id=127df89c&scoped=true&"
import script from "./GenerateTab.vue?vue&type=script&lang=ts&"
export * from "./GenerateTab.vue?vue&type=script&lang=ts&"
import style0 from "./GenerateTab.vue?vue&type=style&index=0&id=127df89c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127df89c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VSnackbar,VTextField})
